import React from 'react';
import TopBarMain from '../components/topbars/TopBarMain';

class NextReunionPage extends React.Component {
    constructor(props) {
        super(props);


    }

    render() {
        return (
            <div>
                <TopBarMain />
                <h2 style={{ textAlign: 'center' }}>Next Reunion</h2>
                <h3 style={{ textAlign: 'center' }}>
                    No information available yet, check back soon!
                </h3>
            </div>
        )
    }
}

export default NextReunionPage;
